import { render, staticRenderFns } from "./TaxListTable.vue?vue&type=template&id=fd389e02&"
import script from "./TaxListTable.vue?vue&type=script&lang=js&"
export * from "./TaxListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports